import { Component, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../../../auth/auth.service';
import { AbstractControl, FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MenuService } from '../../menu/menu.service';
import { Validacion } from '../../../../asistente-en-linea/models/Validacion';
import { ValidacionesService } from '../validaciones.service';
import { TipoValidacion } from '../../../../asistente-en-linea/models/TipoValidacion';
import { TiposValidacionesService } from '../tiposvalidaciones.service';
import { CampoTipoValidacion } from '../../../../asistente-en-linea/models/CampoTipoValidacion';

@Component({
  selector: 'app-validacion',
  templateUrl: './validacion.component.html',
  styleUrls: ['./validacion.component.scss']
})
export class ValidacionComponent implements OnInit {
  cargandoDatos: boolean;
  validacionTipoSeleccionada: TipoValidacion;
  camposTipoValidacion: CampoTipoValidacion[];
  codigo: string;
  nombre: string;
  titulo: string = "";
  etiqueta: string = "";
  tipo: String= "";
  error: string;
  targetType: string = "EMAIL";
  encoladoMaximo: number;
  reenviarHistorico = true;
  habilitado: boolean;
  editando: boolean;
  idValidacion: string;
  loading: boolean;
  errorValidacion: boolean;
  esUsuarioAdminitrador: boolean;
  horaInicio: string = "";
  horaFin: string = "";
  tiposDestinatarioMap: Map<string, string>;
  tiposDestinatarioReverseMap = new Map<string, string>()
  tiposDestinatarioList: string[];
  tiposValidaciones: TipoValidacion[];
  opcionesTipo: { label: string; value: string }[] = [
    { label: "Todos", value: "Todos" }
  ];
  constructor(private validacionService: ValidacionesService,
    private tiposValidacionesService: TiposValidacionesService,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private readonly menuService: MenuService) {
    this.loading = false;
    this.errorValidacion = false;
    this.esUsuarioAdminitrador = false;
  }



  ngOnInit() {
    this.habilitado = true;
    this.loadValidacionesTipos();
    this.route.queryParamMap.subscribe((params: any) => {
      this.idValidacion = params.params.idValidacion;
      if (this.idValidacion) {
        this.editando = true;
        this.loadValidacion();
      }
    })
  }

  loadValidacionesTipos() {
    this.cargandoDatos = true;
    this.tiposValidaciones = [];
    this.tiposValidacionesService.loadTiposValidaciones(true).subscribe((data: any) => {
      if (data && (data.statusCode == 200 || data.statusCode == 0)) {
        if (data.content.length > 0) {
          for (let m of data.content) {
            let tipoVal = new TipoValidacion(
              m.id,
              m.codigo,
              m.nombre,
              m.campos
            );
            this.tiposValidaciones.push(tipoVal);
            this.opcionesTipo.push({ label: m.nombre, value: m.id });
          }
        }
        this.cargandoDatos = false;
      }
      else {
        alert(data.statusMessage);
        this.cargandoDatos = false;
      }
    }, error => {
      alert(error);
      this.cargandoDatos = false;
    })
  }

  volver() {
    this.router.navigate(['/config/validaciones']);
  }

  loadValidacion() {
    this.cargandoDatos = true;
    this.validacionService.loadValidacionByID(this.idValidacion).subscribe((data: any) => {
     // debugger
      if (data && (data.statusCode == 200 || data.statusCode == 0)) {
        let menuBD = data.content;
        this.habilitado = menuBD.habilitado != null ? menuBD.habilitado : false;
        this.nombre = menuBD.nombre;
        this.tipo = menuBD.tipo ? menuBD.tipo.id : "";
        this.validacionTipoSeleccionada = menuBD.tipo;
        if(this.validacionTipoSeleccionada) {
          this.camposTipoValidacion = this.validacionTipoSeleccionada.campos;
          //this.etiqueta = this.validacionTipoSeleccionada.etiqueta;
        }
        this.codigo = menuBD.codigo;
        this.cargandoDatos = false;
      }
      else {
        alert(data.statusMessage);
        this.cargandoDatos = false;
      }
    },
      error => {
        alert(error);
        this.cargandoDatos = false;
      })
  }


  irPaginaInicio() {
    this.router.navigate(['/config/validaciones/']);
  }

  cancelOperation() {
    this.irPaginaInicio();
  }

  cambioTipoValidacion(value: string) {
    this.validacionTipoSeleccionada = this.tiposValidaciones.find(x => x.id === value);
    if(this.validacionTipoSeleccionada) {
      this.camposTipoValidacion = this.validacionTipoSeleccionada.campos;
      //console.log("this.validacionTipoSeleccionada",this.validacionTipoSeleccionada);
      //this.etiqueta = this.validacionTipoSeleccionada.etiqueta;
    }
  }

  async applyOperation() {
    if(this.validacionTipoSeleccionada) {
      this.validacionTipoSeleccionada.campos = this.camposTipoValidacion;
    }
    
    let resArray = [];
    this.errorValidacion = false;
    
    if (this.isCreateValidacionDataValid()) {
        this.loading = true;
        let idDest;
        
        let tipo = this.targetType
        if (this.idValidacion) {
          resArray.push(await this.validacionService.actualizarValidacion(this.idValidacion, this.codigo, this.nombre, this.validacionTipoSeleccionada, this.authService.getUser().username, this.habilitado)
            .toPromise().catch((err) => {
              this.loading = false;
              alert(err);
            }));
        } else {
          resArray.push(await this.validacionService.agregarValidacion(this.codigo, this.nombre, this.validacionTipoSeleccionada,this.authService.getUser().username)
            .toPromise().catch((err) => {
              this.loading = false;
              alert(err);
            }));
        }

        let noErr = resArray.reduce((previous, current) => {
          idDest = current.id;
          return previous && (current.statusCode == 200 || current.statusCode == 0 ? true : false);
        }, true)

        if (noErr) {
          this.loading = false;
          let idDestFin = 0;
          if (idDest) {
            idDestFin = Number(idDest);
          }
          if (idDestFin < 0) {
            if (idDest === '-1') {
              this.error = "Atención: Ya existe otra validación con el mismo código";
            } 
            this.errorValidacion = true;
          } else {
            this.irPaginaInicio();
          }
        } else {
          this.loading = false;
          alert("Ocurrió un error, intente nuevamente más tade");
        }
    } else {
      this.errorValidacion = true;
    }

  }

  isCreateValidacionDataValid() {
    this.error = "";
    if (this.codigo && this.nombre && this.validacionTipoSeleccionada ) {
      this.camposTipoValidacion.forEach(campo => {
        if(!campo.valor) {
          this.error = this.error.length == 0 ? "Por favor, asegúrese de ingresar todos los campos obligatorios" : this.error;
          return false;
        }
      });
      return true;
    } else {
      this.error = this.error.length == 0 ? "Por favor, asegúrese de ingresar todos los campos obligatorios" : this.error;
      return false;
    }
  }

  salirAdministrador() {
    this.menuService.salirAdministrador();
    this.router.navigate(["/login"]);
  }

}